import Header from "../components/Header";
import ReservationForm from "../components/ReservationForm";
import ManageReserveHeader from "../components/ManageReserveHeader";
import scroll from "../css/scroll.module.css"

function ManagerRsvRegi() {


    return (
        <div className={scroll.scroll}>
            <Header />
            <ManageReserveHeader page={"reservation"} />


            <section className={scroll.scroll_section}>
                <ReservationForm />
            </section>
        </div>
    )
}

export default ManagerRsvRegi;